module.exports = __webpack_public_path__ + "img/empty.915ff7ae.png";